import { Environment } from "../environments/Environment";
import { Loader } from '@googlemaps/js-api-loader';

export class FooterComponent {

  _footerEl = null;
  _footerMapGermanyEl = null;
  _footerMapPolandEl = null;
  _googleMapsLoader = null;
  _maps = null;

  init() {
    this._footerEl = document.querySelector('.footer');

    if (this._footerEl) {
      this.afterComponentRender();
    }
  }

  afterComponentRender() {
    this._footerMapGermanyEl = this._footerEl.querySelector('.footer__contact-section__box__map--germany');
    this._footerMapPolandEl = this._footerEl.querySelector('.footer__contact-section__box__map--poland');
  }

  loadMap() {
    this._googleMapsLoader = new Loader({
      apiKey: Environment.googleMapsKey,
    });

    this._googleMapsLoader.load().then(google => {
      this._maps = google.maps;

      this.renderMap(
        this._footerMapGermanyEl,
        {
          lat: 48.146974,
          lng: 11.459576
        },
        {
          lat: 48.150504,
          lng: 11.481581
        }
      );
      this.renderMap(
        this._footerMapPolandEl,
        {
          lat: 50.2913069153847,
          lng: 18.662267168038312
        },
        {
          lat: 50.2913069153847,
          lng: 18.662267168038312
        }
      );
    });
  }

  renderMap(containerEl, markerPosition, mapPosition) {
    const mapOptions = {
      center: mapPosition,
      zoom: 13,
      disableDefaultUI: true,
      styles: [
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e9e9e9"
            },
            {
              "lightness": 17
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            },
            {
              "lightness": 20
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "lightness": 17
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "lightness": 29
            },
            {
              "weight": 0.2
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "lightness": 18
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            },
            {
              "lightness": 21
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dedede"
            },
            {
              "lightness": 21
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#ffffff"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "saturation": 36
            },
            {
              "color": "#333333"
            },
            {
              "lightness": 40
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f2f2f2"
            },
            {
              "lightness": 19
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#fefefe"
            },
            {
              "lightness": 20
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#fefefe"
            },
            {
              "lightness": 17
            },
            {
              "weight": 1.2
            }
          ]
        }
      ]
    };

    const map = new this._maps.Map(containerEl, mapOptions);

    new this._maps.Marker({
      position: markerPosition,
      map: map,
      icon: '/assets/img/icons/marker.webp'
    });
  }
}
